export default __webpack_public_path__ + "static/demo_keberkesanan_sabun_champaca_4-52fe05ccfeea8c22bde30790f12d18e4.mp4";